module.exports = __webpack_public_path__ + "static/media/logo-white.0e96f2a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/logo-white.svg
// module id = 794
// module chunks = 0